<div class="container-fluid" style="margin-bottom: 20px; padding-bottom: 20px;">
  <p-panel class="eca-card">
    <ng-template pTemplate="header" class="eca-secondary-bg" style="color: white">
      <div class="row" style="padding: 5px!important ; width:100% !important;">
        <div class="col-auto d-flex align-items-center" style="padding-right: 0 !important;">
          <div class="d-flex align-items-center">
            <h3 style="margin-bottom: 0 !important;" class="list-page-main-header">
              <span ><fa-icon [icon]="['fad', 'users']"> </fa-icon> Operatives </span>
            </h3>
          </div>
        </div>
        <div class="col pull-right">
          <app-eca-ghost-btn class="card-action-icon float-right" btnIcon="question-circle" btnType="warning" (btnClicked)="openOperativesHelp()"></app-eca-ghost-btn>
          <app-eca-ghost-btn class="float-right" btnText="EAS" btnIcon="bolt" btnType="warning" (btnClicked)="openRiskHelp()"></app-eca-ghost-btn>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="content" class="eca-card-body">
      <div *ngIf="loadingOperatives" class="text-center">
        <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen"
                         secondaryColor="green"></fa-duotone-icon>
      </div>
      <div *ngIf="!loadingOperatives ">
        <app-operative-list [companyId]="companyId" [operatives]="operatives" [allRisks]="allRisks" [isShowAllButtonVisible]="true" [loadedOperativesSubject]="loadedOperativesSubject"
                            (asOfDate)="asOfSelected($event)"
                            [allJobLevels]="allJobLevels"
                            [allJobTitles]="allJobTitles"
                            [allCompanyJobTitles]="allCompanyJobTitles"
                            [allOperativeTypes]="allOperativeTypes"
                            [allBusinessUnits]="allBusinessUnits"
                            [allEmploymentStatuses]="allEmploymentStatuses"
                            [allowedOperations]="loggedInUser?.observationOperations"
                            [riskMatrix]="riskMatrix"
                            (loadAllHistoryOperatives)="reloadOperatives('',$event)"
                            (refreshOperativesRequested)="reloadOperatives($event)">
        </app-operative-list>
      </div>
    </ng-template>
  </p-panel>
</div>
